import React from "react";

const RadioGroup = (props) => {
  const {
    controleId,
    comp,
    stateData: data,
    stateErrors: errors,
    isDisabled,
    handeOnChange,
  } = props;

  const selectedValue = String(data[controleId] ?? "");
  const radioOptions = Array.isArray(comp.radioValues) ? comp.radioValues : [];

  return (
    <div className={`form-group ${comp.isRequired ? "required" : ""} ${comp?.cssclass || ""}`} style={{ marginBottom: "16px" }}>
      <style>{`
        .wf-radio-options {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 10px 22px;
        }
        .wf-radio-option {
          position: relative;
          display: inline-flex !important;
          align-items: center !important;
          gap: 9px !important;
          min-height: 32px;
          margin: 0 !important;
          cursor: pointer;
        }
        .wf-radio-native {
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          margin: 0 !important;
          opacity: 0 !important;
          pointer-events: none;
        }
        .wf-radio-indicator {
          position: relative;
          width: 18px !important;
          height: 18px !important;
          flex: 0 0 18px !important;
          border: 2px solid #94a3b8 !important;
          border-radius: 50% !important;
          background: #ffffff !important;
          box-shadow: none !important;
          box-sizing: border-box !important;
        }
        .wf-radio-native:checked + .wf-radio-indicator {
          border-color: #172b4d !important;
          box-shadow: 0 0 0 3px rgba(23, 43, 77, 0.12) !important;
        }
        .wf-radio-native:checked + .wf-radio-indicator::after {
          content: "";
          position: absolute;
          inset: 3px;
          border-radius: 50% !important;
          background: #172b4d;
        }
        .wf-radio-native:focus-visible + .wf-radio-indicator {
          outline: 2px solid #2563eb;
          outline-offset: 2px;
        }
        .wf-radio-option.is-disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      `}</style>
      {comp.label && (
        <label className="form-control-label" style={{
          fontSize: "11px",
          fontWeight: 700,
          color: "#64748b",
          textTransform: "uppercase",
          letterSpacing: "0.7px",
          marginBottom: "10px",
          display: "block"
        }}>
          {comp.label}
        </label>
      )}

      <div className="wf-radio-options">
        {radioOptions.map((item, key) => {
          const inputId = `${controleId}${key}`;
          const itemValue = item.value ?? item.name ?? "";
          const isChecked = selectedValue === String(itemValue);

          return (
            <label
              key={inputId}
              htmlFor={inputId}
              className={`wf-radio-option ${isDisabled ? "is-disabled" : ""}`}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "9px",
                minHeight: "32px",
                margin: 0,
                color: "#334155",
                cursor: isDisabled ? "not-allowed" : "pointer",
                fontFamily: "Inter, Roboto, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: 1.2,
                opacity: isDisabled ? 0.68 : 1,
                userSelect: "none"
              }}
            >
              <input
                className="wf-radio-native"
                type="radio"
                id={inputId}
                name={controleId}
                value={itemValue}
                checked={isChecked}
                onChange={handeOnChange}
                disabled={isDisabled}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none"
                }}
              />
              <span
                className="wf-radio-indicator"
                aria-hidden="true"
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  border: isChecked ? "5px solid #2b62a1" : "1.5px solid #cbd5e1",
                  backgroundColor: "#ffffff",
                  boxShadow: isChecked ? "0 0 0 3px rgba(43, 98, 161, 0.12)" : "inset 0 0 0 3px #f8fafc",
                  boxSizing: "border-box",
                  flex: "0 0 18px",
                  transition: "border-color 0.15s ease, border-width 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease"
                }}
              />
              <span>
                {item.name}
              </span>
            </label>
          );
        })}
      </div>

      {errors[controleId] && (
        <div className="alert alert-danger" style={{ marginTop: 8, padding: "5px 10px", fontSize: "11.5px", borderRadius: "7px", display: "inline-block" }}>
          {errors[controleId]}
        </div>
      )}
    </div>
  );
}

export default RadioGroup;
